import { render, staticRenderFns } from "./StepperHeaderResponsive.vue?vue&type=template&id=6970aeae&scoped=true"
import script from "./StepperHeaderResponsive.vue?vue&type=script&lang=ts"
export * from "./StepperHeaderResponsive.vue?vue&type=script&lang=ts"
import style0 from "./StepperHeaderResponsive.vue?vue&type=style&index=0&id=6970aeae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6970aeae",
  null
  
)

export default component.exports